// src/config/webhooks.ts
export const LEAD_WEBHOOK_URL =
  import.meta.env.VITE_LEAD_WEBHOOK_URL ||
  "https://services.leadconnectorhq.com/hooks/mJ6B1jcjkJu1n25f6ShI/webhook-trigger/8a557f79-cc3c-4349-a4c0-ca8f392a85eb";

export const TRAINING_FEEDBACK_WEBHOOK_URL =
  import.meta.env.VITE_TRAINING_FEEDBACK_WEBHOOK_URL || 
  "https://services.leadconnectorhq.com/hooks/mJ6B1jcjkJu1n25f6ShI/webhook-trigger/3efd4a36-85eb-40d9-a23e-be864b5c5c9e";
